<template>
  <div id="club">
    <div class="club_tit">동아리방(Community)</div>
    <div class="club_cont">
      <div class="club_cont_item">
        <div class="cont_tit">이용방법</div>
        <div class="cont_desc">
          사전 예약제<br>
          (예약전화: 02-6737-7448~9)
        </div>
      </div>
      <div class="club_cont_item">
        <div class="cont_tit">준수사항</div>
        <div class="cont_desc">같은 방향과 목표를 향해 이용하는 중장년(만35세이상) 구직자 자유로운 활동영역을 펼치는 공간</div>
      </div>
      <div class="club_cont_item">
        <div class="cont_tit">알림사항*</div>
        <div class="cont_desc">
          동아리방 이름을 공모 중 입니다!<br>
          잘 어울리는 동아리방의 이름을 응모해주시면 채택되신분께는 소정의 상품을 증정합니다.
        </div>
      </div>
    </div>
    <div class="club_list">
      <div class="club_item">
        <img src="../../assets/club/ic_club_01.svg"/>
        <div class="tit">대상</div>
        <div class="desc">
          재취업을 준비하는<br>
          구로구 중장년 구직자
        </div>
      </div>
      <div class="club_item">
        <img src="../../assets/club/ic_club_02.svg"/>
        <div class="tit">운영시간</div>
        <div class="desc">
          평일<br>
          10:00~17:00<br>
          (회당 2~3시간)
        </div>
      </div>
      <div class="club_item">
        <img src="../../assets/club/ic_club_03.svg"/>
        <div class="tit">사용방법</div>
        <div class="desc">
          사전 예약제<br>
          사무실에 꼭 문의해주세요<br>
          (02-6737-7448~9)
        </div>
      </div>
      <div class="club_item">
        <img src="../../assets/club/ic_club_04.svg"/>
        <div class="tit">운영내용</div>
        <div class="desc">
          구인,구직 채용시장<br>
          정보공유<br>
          그룹 시너지 효과
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
  }
}
</script>

<style scoped>
.mobile_wrap #club {
  padding: 0 16px;
  box-sizing: border-box;
}

.club_tit {
  margin-top: 55px;
  color: #0F1015;
  font-size: 38px;
  font-weight: 400;
  text-align: left;
}

.mobile_wrap .club_tit {
  margin-top: 40px;
  font-size: 18px;
}

.club_cont {
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  gap: 30px;
}

.mobile_wrap .club_cont {
  margin-top: 40px;
  gap: 15px;
}

.club_cont > .club_cont_item {
  display: flex;
}

.club_cont > .club_cont_item > div {
  color: #1F1F1F;
  font-weight: 400;
  letter-spacing: 0.7px;
  text-align: left;
}

.club_cont > .club_cont_item > .cont_tit {
  width: 100px;
  font-size: 20px;
  line-height: 27px; /* 135% */
}

.mobile_wrap .club_cont > .club_cont_item > .cont_tit {
  flex-shrink: 0;
  width: 80px;
  font-size: 16px;
  line-height: 1.5;
}

.club_cont > .club_cont_item > .cont_desc {
  font-size: 16px;
  line-height: 27px; /* 168.75% */
}

.mobile_wrap .club_cont > .club_cont_item > .cont_desc {
  font-size: 14px;
  line-height: 1.5;
}

.club_list {
  display: flex;
  width: 100%;
  margin: 80px 0 180px;
  gap: 30px;
}

.mobile_wrap .club_list {
  flex-wrap: wrap;
  margin: 40px 0 100px;
  gap: 15px;
}

.club_list > .club_item {
  display: flex;
  flex-direction: column;
  width: 25%;
  height: 250px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.05);
}

.mobile_wrap .club_list > .club_item {
  height: auto;
  padding-bottom: 20px;
}

.mobile_wrap .club_list > .club_item {
  width: calc(50% - 7.5px);
}

.club_list > .club_item > img {
  margin: 40px auto 0;
}

.mobile_wrap .club_list > .club_item > img {
  margin: 20px auto 0;
}

.club_list > .club_item > .tit {
  margin: 18px auto 0;
  color: #14171D;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.2;
}

.mobile_wrap .club_list > .club_item > .tit {
  margin-top: 10px;
  font-size: 16px;
}

.club_list > .club_item > .desc {
  margin: 25px auto auto;
  color: #606267;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.mobile_wrap .club_list > .club_item > .desc {
  margin-top: 16px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/participation/Club.vue